import { render } from "./resignation-index.vue?vue&type=template&id=cc03147c"
import script from "./resignation-index.vue?vue&type=script&lang=js"
export * from "./resignation-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__